import { render, staticRenderFns } from "./jtDetail.vue?vue&type=template&id=21af707a&scoped=true&"
import script from "./jtDetail.vue?vue&type=script&lang=js&"
export * from "./jtDetail.vue?vue&type=script&lang=js&"
import style0 from "./jtDetail.vue?vue&type=style&index=0&id=21af707a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af707a",
  null
  
)

export default component.exports